import React, { useEffect, useState } from 'react';
import { X, Settings } from 'lucide-react';
export const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false
  });
  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      ...preferences,
      analytics: true,
      marketing: true
    }));
    setShowBanner(false);
  };
  const handleDecline = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      necessary: true,
      analytics: false,
      marketing: false
    }));
    setShowBanner(false);
  };
  const handleSavePreferences = () => {
    localStorage.setItem('cookieConsent', JSON.stringify(preferences));
    setShowBanner(false);
    setShowSettings(false);
  };
  if (!showBanner) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 animate-slideUp" data-id="element-515">
      <div className="bg-white border-t-2 border-gray-200 shadow-2xl" data-id="element-516">
        <div className="container py-4" data-id="element-517">
          {!showSettings ? <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-518">
              <div className="flex-1" data-id="element-519">
                <p className="text-gray-700 text-sm" data-id="element-520">
                  We use cookies on our website to see how you interact with it.
                  By accepting, you agree to our use of such cookies.{' '}
                  <a href="/legal/privacy" className="text-primary-600 hover:underline font-semibold" data-id="element-521">
                    Privacy Policy
                  </a>
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-522">
                <button onClick={() => setShowSettings(true)} className="flex items-center gap-2 px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors duration-200" aria-label="Cookie settings" data-id="element-523">
                  <Settings size={18} data-id="element-524" />
                  Settings
                </button>
                <button onClick={handleDecline} className="px-6 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors duration-200 font-semibold" data-id="element-525">
                  Decline
                </button>
                <button onClick={handleAccept} className="px-6 py-2 bg-primary-600 hover:bg-primary-700 text-white rounded-lg transition-colors duration-200 font-semibold" data-id="element-526">
                  Accept
                </button>
              </div>
            </div> : <div className="space-y-4" data-id="element-527">
              <div className="flex items-center justify-between" data-id="element-528">
                <h3 className="text-lg font-bold text-gray-900" data-id="element-529">
                  Cookie Preferences
                </h3>
                <button onClick={() => setShowSettings(false)} className="text-gray-400 hover:text-gray-600" aria-label="Close settings" data-id="element-530">
                  <X size={24} data-id="element-531" />
                </button>
              </div>

              <div className="space-y-3" data-id="element-532">
                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-533">
                  <div data-id="element-534">
                    <p className="font-semibold text-gray-900" data-id="element-535">
                      Necessary Cookies
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-536">
                      Required for the website to function
                    </p>
                  </div>
                  <input type="checkbox" checked={preferences.necessary} disabled className="w-5 h-5 text-primary-600 rounded" data-id="element-537" />
                </div>

                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-538">
                  <div data-id="element-539">
                    <p className="font-semibold text-gray-900" data-id="element-540">
                      Analytics Cookies
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-541">
                      Help us improve our website
                    </p>
                  </div>
                  <input type="checkbox" checked={preferences.analytics} onChange={e => setPreferences({
                ...preferences,
                analytics: e.target.checked
              })} className="w-5 h-5 text-primary-600 rounded" data-id="element-542" />
                </div>

                <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg" data-id="element-543">
                  <div data-id="element-544">
                    <p className="font-semibold text-gray-900" data-id="element-545">
                      Marketing Cookies
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-546">
                      Used for personalized advertising
                    </p>
                  </div>
                  <input type="checkbox" checked={preferences.marketing} onChange={e => setPreferences({
                ...preferences,
                marketing: e.target.checked
              })} className="w-5 h-5 text-primary-600 rounded" data-id="element-547" />
                </div>
              </div>

              <div className="flex justify-end gap-3" data-id="element-548">
                <button onClick={() => setShowSettings(false)} className="px-6 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors duration-200 font-semibold" data-id="element-549">
                  Cancel
                </button>
                <button onClick={handleSavePreferences} className="px-6 py-2 bg-primary-600 hover:bg-primary-700 text-white rounded-lg transition-colors duration-200 font-semibold" data-id="element-550">
                  Save Preferences
                </button>
              </div>
            </div>}
        </div>
      </div>
    </div>;
};